import React from "react";
import No from "../img/data-not-found.webp";
const NoRowsMessage = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={No}
        width="100px"
        alt=""
        style={{ position: "relative", top: "200px" }}
      />
    </div>
  );
};

export default NoRowsMessage;
